<template>
    <div class="qulity">
       <router-view></router-view>
    </div>
</template>

<script>
export default {
    name:'qulity',
    data(){
        return{
            
        }
    },
    methods:{
        
    }
}
</script>

<style scoped>



</style>